import { CountingType } from 'capacity/types'
import { PRODUCTS } from 'capacity/copy'
import { ProductWindow } from 'timeSlots/domain/applicableGroups'

export interface WindowedProduct {
    name: string
    window: ProductWindow
}

export type WindowSummary =
    | { kind: 'empty' }
    | { kind: 'noneSlotted' }
    | { kind: 'slotted' }
    | { kind: 'mixed'; dayProductNames: string[]; slotProductNames: string[] }

export function windowSummary(products: WindowedProduct[]): WindowSummary {
    if (products.length === 0) {
        return { kind: 'empty' }
    }
    const slotted = products.filter((product) => product.window === 'slot')
    const wholeDay = products.filter((product) => product.window !== 'slot')
    if (slotted.length === 0) {
        return { kind: 'noneSlotted' }
    }
    if (wholeDay.length === 0) {
        return { kind: 'slotted' }
    }
    return {
        kind: 'mixed',
        dayProductNames: wholeDay.map((product) => product.name),
        slotProductNames: slotted.map((product) => product.name),
    }
}

export function mixedConsequence(countingType: CountingType, summary: WindowSummary): string | null {
    if (summary.kind !== 'mixed') {
        return null
    }
    return countingType === 'arrivalOnly'
        ? PRODUCTS.consequence.arrivalOnly(summary.dayProductNames, summary.slotProductNames)
        : PRODUCTS.consequence.wholeTimeSlot(summary.dayProductNames, summary.slotProductNames)
}
